export default __webpack_public_path__ + "img/47.74f55d.png";